const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Szia',
    'Ref: Page content body':
      'Érkezéskor és induláskor kérjük, ne felejtse el beolvasni a QR -kód buszját',
  },
};
export default labels;
